import React from "react"
import { Chip, IconButton, FontIcon } from "material-ui"
import autobind from "class-autobind"
import AddSupervisorDialogForChip from "./AddSupervisorDialogForChip"
import { ISupervisor } from "../../models"
import strings from "../../localization/strings"
import * as api from "../../api"
import AccountStore from "../../stores/AccountStore"
import _ from "lodash"

interface IProps {
    readonly: boolean
    selectedSupervisorIds: string[]
    canChooseYourSelf?: boolean
    supervisorRestrictHierarchyId?: string
    employeePermissionHierarchy?: string
    error?: string
    hideLabel?: boolean
    maxCountShow?: number
    handleChange?(selectedSupervisors: ISupervisor[]): void
}
interface IState {
    loading: boolean
    selectedSupervisors: ISupervisor[]
    openAddSupervisorDialog: boolean
}

export default class MultiSupervisorChips extends React.Component<IProps, IState> {
    constructor(props: IProps) {
        super(props)
        this.state = {
            loading: props.selectedSupervisorIds && props.selectedSupervisorIds.length > 0,
            selectedSupervisors: [],
            openAddSupervisorDialog: false,
        }
        autobind(this)
    }

    componentDidMount() {
        this.getSelectedSupervisors(this.props.selectedSupervisorIds)
    }

    componentWillReceiveProps(nextProps: IProps) {
        !_.isEqual(this.props.selectedSupervisorIds, nextProps.selectedSupervisorIds) &&
            this.getSelectedSupervisors(nextProps.selectedSupervisorIds)
    }

    getSelectedSupervisors(supervisorIds: string[]) {
        supervisorIds && supervisorIds.length > 0 &&
            api.getSupervisors(AccountStore.getCurrentAccount().Id, supervisorIds)
                .then(res =>
                    this.setState({
                        loading: false,
                        selectedSupervisors: res.data
                    })
                )
    }

    render() {
        return (
            <div>
                {!this.props.hideLabel &&
                    <div>
                        <span>{strings.Supervisors}</span>
                        <span style={{ color: "rgb(244, 67, 54)", fontSize: 12, marginLeft: 15 }}>{this.props.error}</span>
                    </div>
                }
                <div style={{ display: "flex", flexWrap: "wrap" }}>
                    {this.state.loading ?
                        <Chip style={{ margin: 5, cursor: "pointer" }}>
                            {strings.loading}
                        </Chip> :
                        this.state.selectedSupervisors.length > 0 && (
                            (!this.props.maxCountShow || this.state.selectedSupervisors.length <= this.props.maxCountShow) ?
                                this.state.selectedSupervisors.map(supervisor =>
                                    <Chip
                                        key={supervisor.Id}
                                        style={{ margin: 5, cursor: "pointer" }}
                                        title={`${supervisor.FirstName} ${supervisor.LastName}`}
                                        onRequestDelete={this.props.readonly ?
                                            null :
                                            () => {
                                                const selectedSupervisors = this.state.selectedSupervisors.filter(i => i.Id !== supervisor.Id)
                                                this.setState({ selectedSupervisors })
                                                this.props.handleChange(selectedSupervisors)
                                            }}
                                    >
                                        {`${supervisor.FirstName} ${supervisor.LastName}`}
                                    </Chip>
                                ) :
                                (() => {
                                    const supervisorNames = this.state.selectedSupervisors.map(supervisor => `${supervisor.FirstName} ${supervisor.LastName}`)
                                    const multiTitle = supervisorNames.join(", ")
                                    return (
                                        <span title={multiTitle}>{strings.MULT}</span>
                                    )
                                })()
                        )
                    }
                    {!this.props.readonly &&
                        <IconButton
                            style={{ height: 35, width: 35, padding: 0, margin: 0, display: "inline-block" }}
                            onTouchTap={() => this.setState({ openAddSupervisorDialog: true })}
                        >
                            <FontIcon className="fa fa-plus-circle" />
                        </IconButton>
                    }
                </div>
                {this.state.openAddSupervisorDialog &&
                    <AddSupervisorDialogForChip
                        selectedSupervisorIds={this.state.selectedSupervisors.map(i => i.Id)}
                        canChooseYourSelf={this.props.canChooseYourSelf}
                        supervisorRestrictHierarchyId={this.props.supervisorRestrictHierarchyId}
                        employeePermissionHierarchy={this.props.employeePermissionHierarchy}
                        handleClose={() => this.setState({ openAddSupervisorDialog: false })}
                        handleUpdateSupervisor={supervisor => {
                            const selectedSupervisors = this.state.selectedSupervisors
                            selectedSupervisors.push(supervisor)
                            this.setState({ selectedSupervisors, openAddSupervisorDialog: false })
                            this.props.handleChange(selectedSupervisors)
                        }}
                    />
                }
            </div>
        )
    }
}